import { SendDatahubConsumeProps } from 'src/utils/datahub/types';
import { CommunityMemberPermissionsGroup } from 'src/services/community';
import useMembership from '../useMembership';
import { useUser } from '../useUser';
import useDispatchDatahubCommunity from '../useDispatchDatahubCommunity';
import { useSessionData } from '../useSessionData';

const useSendDataHubConsume = () => {
  const { membership } = useMembership();
  const { user, permissionsUser } = useUser();
  const { dispatchDatahubCommunity } = useDispatchDatahubCommunity();
  const { user: userData, membership: membershipData } = useSessionData();

  const sendDataHubConsume = ({ entity, action, event, system }: SendDatahubConsumeProps) => {
    dispatchDatahubCommunity({
      action,
      entity,
      system,
      membershipData: {
        membershipSlug: membership?.slug || membershipData?.slug,
        membershipName: membership?.name || membershipData?.name
      },
      userData: {
        userName: user?.name || userData?.name,
        userRole: permissionsUser?.group || CommunityMemberPermissionsGroup.VIEWER,
        ucode: user?.ucode || userData?.ucode,
        marketplaceId: Number(user?.id || userData?.id)
      },
      appVersion: process.env.PROJECT_VERSION,
      event
    });
  };

  return { sendDataHubConsume };
};

export default useSendDataHubConsume;
